import { CurrencyModelResponse } from './currency.model';
import { CurrenciesInterfaceResponse } from '../interfaces/currencies.interface';
import { CurrencyInterfaceResponse } from '../interfaces/currency.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CurrenciesModelResponse')
export class CurrenciesModelResponse implements CurrenciesInterfaceResponse {
  @JsonProperty('BaseCurrency', String, true)
  baseCurrency: string = undefined;

  @JsonProperty('Currencies', [CurrencyModelResponse], true)
  currencies: CurrencyInterfaceResponse[] = undefined;
}
